export function SocialMediaIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_7445_378)">
        <path
          d="M12 2.16094C15.2063 2.16094 15.5859 2.175 16.8469 2.23125C18.0188 2.28281 18.6516 2.47969 19.0734 2.64375C19.6313 2.85938 20.0344 3.12188 20.4516 3.53906C20.8734 3.96094 21.1313 4.35938 21.3469 4.91719C21.5109 5.33906 21.7078 5.97656 21.7594 7.14375C21.8156 8.40937 21.8297 8.78906 21.8297 11.9906C21.8297 15.1969 21.8156 15.5766 21.7594 16.8375C21.7078 18.0094 21.5109 18.6422 21.3469 19.0641C21.1313 19.6219 20.8687 20.025 20.4516 20.4422C20.0297 20.8641 19.6313 21.1219 19.0734 21.3375C18.6516 21.5016 18.0141 21.6984 16.8469 21.75C15.5813 21.8062 15.2016 21.8203 12 21.8203C8.79375 21.8203 8.41406 21.8062 7.15313 21.75C5.98125 21.6984 5.34844 21.5016 4.92656 21.3375C4.36875 21.1219 3.96563 20.8594 3.54844 20.4422C3.12656 20.0203 2.86875 19.6219 2.65313 19.0641C2.48906 18.6422 2.29219 18.0047 2.24063 16.8375C2.18438 15.5719 2.17031 15.1922 2.17031 11.9906C2.17031 8.78438 2.18438 8.40469 2.24063 7.14375C2.29219 5.97187 2.48906 5.33906 2.65313 4.91719C2.86875 4.35938 3.13125 3.95625 3.54844 3.53906C3.97031 3.11719 4.36875 2.85938 4.92656 2.64375C5.34844 2.47969 5.98594 2.28281 7.15313 2.23125C8.41406 2.175 8.79375 2.16094 12 2.16094ZM12 0C8.74219 0 8.33438 0.0140625 7.05469 0.0703125C5.77969 0.126563 4.90313 0.332812 4.14375 0.628125C3.35156 0.9375 2.68125 1.34531 2.01563 2.01562C1.34531 2.68125 0.9375 3.35156 0.628125 4.13906C0.332812 4.90313 0.126563 5.775 0.0703125 7.05C0.0140625 8.33437 0 8.74219 0 12C0 15.2578 0.0140625 15.6656 0.0703125 16.9453C0.126563 18.2203 0.332812 19.0969 0.628125 19.8563C0.9375 20.6484 1.34531 21.3188 2.01563 21.9844C2.68125 22.65 3.35156 23.0625 4.13906 23.3672C4.90313 23.6625 5.775 23.8687 7.05 23.925C8.32969 23.9812 8.7375 23.9953 11.9953 23.9953C15.2531 23.9953 15.6609 23.9812 16.9406 23.925C18.2156 23.8687 19.0922 23.6625 19.8516 23.3672C20.6391 23.0625 21.3094 22.65 21.975 21.9844C22.6406 21.3188 23.0531 20.6484 23.3578 19.8609C23.6531 19.0969 23.8594 18.225 23.9156 16.95C23.9719 15.6703 23.9859 15.2625 23.9859 12.0047C23.9859 8.74688 23.9719 8.33906 23.9156 7.05938C23.8594 5.78438 23.6531 4.90781 23.3578 4.14844C23.0625 3.35156 22.6547 2.68125 21.9844 2.01562C21.3188 1.35 20.6484 0.9375 19.8609 0.632812C19.0969 0.3375 18.225 0.13125 16.95 0.075C15.6656 0.0140625 15.2578 0 12 0Z"
          fill="#101828"
        />
        <path
          d="M12 5.83594C8.59688 5.83594 5.83594 8.59688 5.83594 12C5.83594 15.4031 8.59688 18.1641 12 18.1641C15.4031 18.1641 18.1641 15.4031 18.1641 12C18.1641 8.59688 15.4031 5.83594 12 5.83594ZM12 15.9984C9.79219 15.9984 8.00156 14.2078 8.00156 12C8.00156 9.79219 9.79219 8.00156 12 8.00156C14.2078 8.00156 15.9984 9.79219 15.9984 12C15.9984 14.2078 14.2078 15.9984 12 15.9984Z"
          fill="#101828"
        />
        <path
          d="M19.8469 5.59214C19.8469 6.38902 19.2 7.0312 18.4078 7.0312C17.6109 7.0312 16.9688 6.38433 16.9688 5.59214C16.9688 4.79526 17.6156 4.15308 18.4078 4.15308C19.2 4.15308 19.8469 4.79995 19.8469 5.59214Z"
          fill="#101828"
        />
      </g>
      <defs>
        <clipPath id="clip0_7445_378">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function SocialMediaIconSm() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_7353_9387)">
        <path
          d="M10 1.80078C12.6719 1.80078 12.9883 1.8125 14.0391 1.85937C15.0156 1.90234 15.543 2.06641 15.8945 2.20313C16.3594 2.38281 16.6953 2.60156 17.043 2.94922C17.3945 3.30078 17.6094 3.63281 17.7891 4.09766C17.9258 4.44922 18.0898 4.98047 18.1328 5.95312C18.1797 7.00781 18.1914 7.32422 18.1914 9.99219C18.1914 12.6641 18.1797 12.9805 18.1328 14.0313C18.0898 15.0078 17.9258 15.5352 17.7891 15.8867C17.6094 16.3516 17.3906 16.6875 17.043 17.0352C16.6914 17.3867 16.3594 17.6016 15.8945 17.7813C15.543 17.918 15.0117 18.082 14.0391 18.125C12.9844 18.1719 12.668 18.1836 10 18.1836C7.32813 18.1836 7.01172 18.1719 5.96094 18.125C4.98438 18.082 4.45703 17.918 4.10547 17.7813C3.64063 17.6016 3.30469 17.3828 2.95703 17.0352C2.60547 16.6836 2.39063 16.3516 2.21094 15.8867C2.07422 15.5352 1.91016 15.0039 1.86719 14.0313C1.82031 12.9766 1.80859 12.6602 1.80859 9.99219C1.80859 7.32031 1.82031 7.00391 1.86719 5.95312C1.91016 4.97656 2.07422 4.44922 2.21094 4.09766C2.39063 3.63281 2.60938 3.29688 2.95703 2.94922C3.30859 2.59766 3.64063 2.38281 4.10547 2.20313C4.45703 2.06641 4.98828 1.90234 5.96094 1.85937C7.01172 1.8125 7.32813 1.80078 10 1.80078ZM10 0C7.28516 0 6.94531 0.0117187 5.87891 0.0585938C4.81641 0.105469 4.08594 0.277344 3.45313 0.523438C2.79297 0.78125 2.23438 1.12109 1.67969 1.67969C1.12109 2.23438 0.78125 2.79297 0.523438 3.44922C0.277344 4.08594 0.105469 4.8125 0.0585938 5.875C0.0117188 6.94531 0 7.28516 0 10C0 12.7148 0.0117188 13.0547 0.0585938 14.1211C0.105469 15.1836 0.277344 15.9141 0.523438 16.5469C0.78125 17.207 1.12109 17.7656 1.67969 18.3203C2.23438 18.875 2.79297 19.2188 3.44922 19.4727C4.08594 19.7188 4.8125 19.8906 5.875 19.9375C6.94141 19.9844 7.28125 19.9961 9.99609 19.9961C12.7109 19.9961 13.0508 19.9844 14.1172 19.9375C15.1797 19.8906 15.9102 19.7188 16.543 19.4727C17.1992 19.2188 17.7578 18.875 18.3125 18.3203C18.8672 17.7656 19.2109 17.207 19.4648 16.5508C19.7109 15.9141 19.8828 15.1875 19.9297 14.125C19.9766 13.0586 19.9883 12.7188 19.9883 10.0039C19.9883 7.28906 19.9766 6.94922 19.9297 5.88281C19.8828 4.82031 19.7109 4.08984 19.4648 3.45703C19.2188 2.79297 18.8789 2.23438 18.3203 1.67969C17.7656 1.125 17.207 0.78125 16.5508 0.527344C15.9141 0.28125 15.1875 0.109375 14.125 0.0625C13.0547 0.0117188 12.7148 0 10 0Z"
          fill="#101828"
        />
        <path
          d="M10 4.86328C7.16406 4.86328 4.86328 7.16406 4.86328 10C4.86328 12.8359 7.16406 15.1367 10 15.1367C12.8359 15.1367 15.1367 12.8359 15.1367 10C15.1367 7.16406 12.8359 4.86328 10 4.86328ZM10 13.332C8.16016 13.332 6.66797 11.8398 6.66797 10C6.66797 8.16016 8.16016 6.66797 10 6.66797C11.8398 6.66797 13.332 8.16016 13.332 10C13.332 11.8398 11.8398 13.332 10 13.332Z"
          fill="#101828"
        />
        <path
          d="M16.5391 4.66016C16.5391 5.32422 16 5.85938 15.3398 5.85938C14.6758 5.85938 14.1406 5.32031 14.1406 4.66016C14.1406 3.99609 14.6797 3.46094 15.3398 3.46094C16 3.46094 16.5391 4 16.5391 4.66016Z"
          fill="#101828"
        />
      </g>
      <defs>
        <clipPath id="clip0_7353_9387">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function VideoListIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.8 10C18.9201 10 19.4802 10 19.908 9.78201C20.2843 9.59027 20.5903 9.28431 20.782 8.90798C21 8.48016 21 7.92011 21 6.8V6.2C21 5.0799 21 4.51984 20.782 4.09202C20.5903 3.7157 20.2843 3.40973 19.908 3.21799C19.4802 3 18.9201 3 17.8 3L6.2 3C5.0799 3 4.51984 3 4.09202 3.21799C3.71569 3.40973 3.40973 3.71569 3.21799 4.09202C3 4.51984 3 5.07989 3 6.2L3 6.8C3 7.9201 3 8.48016 3.21799 8.90798C3.40973 9.28431 3.71569 9.59027 4.09202 9.78201C4.51984 10 5.07989 10 6.2 10L17.8 10Z"
        stroke="#101828"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.8 21C18.9201 21 19.4802 21 19.908 20.782C20.2843 20.5903 20.5903 20.2843 20.782 19.908C21 19.4802 21 18.9201 21 17.8V17.2C21 16.0799 21 15.5198 20.782 15.092C20.5903 14.7157 20.2843 14.4097 19.908 14.218C19.4802 14 18.9201 14 17.8 14L6.2 14C5.0799 14 4.51984 14 4.09202 14.218C3.71569 14.4097 3.40973 14.7157 3.21799 15.092C3 15.5198 3 16.0799 3 17.2L3 17.8C3 18.9201 3 19.4802 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.07989 21 6.2 21H17.8Z"
        stroke="#101828"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function VideoListIconSm() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.8333 8.33333C15.7668 8.33333 16.2335 8.33333 16.59 8.15168C16.9036 7.99189 17.1586 7.73692 17.3183 7.42332C17.5 7.0668 17.5 6.60009 17.5 5.66667V5.16667C17.5 4.23325 17.5 3.76654 17.3183 3.41002C17.1586 3.09641 16.9036 2.84145 16.59 2.68166C16.2335 2.5 15.7668 2.5 14.8333 2.5L5.16667 2.5C4.23325 2.5 3.76654 2.5 3.41002 2.68166C3.09641 2.84144 2.84144 3.09641 2.68166 3.41002C2.5 3.76654 2.5 4.23325 2.5 5.16667L2.5 5.66667C2.5 6.60009 2.5 7.0668 2.68166 7.42332C2.84144 7.73692 3.09641 7.99189 3.41002 8.15168C3.76654 8.33333 4.23325 8.33333 5.16667 8.33333L14.8333 8.33333Z"
        stroke="#101828"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.8333 17.5C15.7668 17.5 16.2335 17.5 16.59 17.3183C16.9036 17.1586 17.1586 16.9036 17.3183 16.59C17.5 16.2335 17.5 15.7668 17.5 14.8333V14.3333C17.5 13.3999 17.5 12.9332 17.3183 12.5767C17.1586 12.2631 16.9036 12.0081 16.59 11.8483C16.2335 11.6667 15.7668 11.6667 14.8333 11.6667L5.16667 11.6667C4.23325 11.6667 3.76654 11.6667 3.41002 11.8483C3.09641 12.0081 2.84144 12.2631 2.68166 12.5767C2.5 12.9332 2.5 13.3999 2.5 14.3333L2.5 14.8333C2.5 15.7668 2.5 16.2335 2.68166 16.59C2.84144 16.9036 3.09641 17.1586 3.41002 17.3183C3.76654 17.5 4.23325 17.5 5.16667 17.5H14.8333Z"
        stroke="#101828"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function LightCRMIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 21V19C22 17.1362 20.7252 15.5701 19 15.126M15.5 3.29076C16.9659 3.88415 18 5.32131 18 7C18 8.67869 16.9659 10.1159 15.5 10.7092M17 21C17 19.1362 17 18.2044 16.6955 17.4693C16.2895 16.4892 15.5108 15.7105 14.5307 15.3045C13.7956 15 12.8638 15 11 15H8C6.13623 15 5.20435 15 4.46927 15.3045C3.48915 15.7105 2.71046 16.4892 2.30448 17.4693C2 18.2044 2 19.1362 2 21M13.5 7C13.5 9.20914 11.7091 11 9.5 11C7.29086 11 5.5 9.20914 5.5 7C5.5 4.79086 7.29086 3 9.5 3C11.7091 3 13.5 4.79086 13.5 7Z"
        stroke="#101828"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function LightCRMIconSm() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.3333 17.5V15.8333C18.3333 14.2801 17.271 12.9751 15.8333 12.605M12.9166 2.7423C14.1382 3.23679 15 4.43443 15 5.83333C15 7.23224 14.1382 8.42988 12.9166 8.92437M14.1666 17.5C14.1666 15.9469 14.1666 15.1703 13.9129 14.5577C13.5746 13.741 12.9257 13.092 12.1089 12.7537C11.4963 12.5 10.7198 12.5 9.16663 12.5H6.66663C5.11349 12.5 4.33692 12.5 3.72435 12.7537C2.90759 13.092 2.25867 13.741 1.92036 14.5577C1.66663 15.1703 1.66663 15.9469 1.66663 17.5M11.25 5.83333C11.25 7.67428 9.75758 9.16667 7.91663 9.16667C6.07568 9.16667 4.58329 7.67428 4.58329 5.83333C4.58329 3.99238 6.07568 2.5 7.91663 2.5C9.75758 2.5 11.25 3.99238 11.25 5.83333Z"
        stroke="#101828"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SmartAdsIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 8.00004V12M10.25 5.50003H6.8C5.11984 5.50003 4.27976 5.50003 3.63803 5.82701C3.07354 6.11463 2.6146 6.57358 2.32698 7.13806C2 7.7798 2 8.61988 2 10.3L2 11.5C2 12.4319 2 12.8979 2.15224 13.2654C2.35523 13.7555 2.74458 14.1448 3.23463 14.3478C3.60218 14.5 4.06812 14.5 5 14.5V18.75C5 18.9822 5 19.0983 5.00963 19.1961C5.10316 20.1456 5.85441 20.8969 6.80397 20.9904C6.90175 21 7.01783 21 7.25 21C7.48217 21 7.59826 21 7.69604 20.9904C8.64559 20.8969 9.39685 20.1456 9.49037 19.1961C9.5 19.0983 9.5 18.9822 9.5 18.75V14.5H10.25C12.0164 14.5 14.1772 15.4469 15.8443 16.3557C16.8168 16.8858 17.3031 17.1509 17.6216 17.1119C17.9169 17.0757 18.1402 16.9431 18.3133 16.7011C18.5 16.4402 18.5 15.918 18.5 14.8737V5.12632C18.5 4.08203 18.5 3.55988 18.3133 3.29892C18.1402 3.05694 17.9169 2.92433 17.6216 2.88816C17.3031 2.84916 16.8168 3.11423 15.8443 3.64439C14.1772 4.55315 12.0164 5.50003 10.25 5.50003Z"
        stroke="#101828"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SmartAdsIconSm() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.3333 6.66672V10.0001M8.54162 4.58338H5.66663C4.26649 4.58338 3.56643 4.58338 3.03165 4.85587C2.56124 5.09555 2.17879 5.478 1.93911 5.94841C1.66662 6.48319 1.66663 7.18325 1.66663 8.58338L1.66663 9.58338C1.66663 10.36 1.66663 10.7482 1.7935 11.0545C1.96265 11.4629 2.28711 11.7874 2.69549 11.9565C3.00177 12.0834 3.39006 12.0834 4.16663 12.0834V15.625C4.16663 15.8185 4.16663 15.9153 4.17465 15.9967C4.25259 16.788 4.87864 17.4141 5.66993 17.492C5.75142 17.5 5.84815 17.5 6.04163 17.5C6.2351 17.5 6.33184 17.5 6.41332 17.492C7.20462 17.4141 7.83067 16.788 7.9086 15.9967C7.91663 15.9153 7.91663 15.8185 7.91663 15.625V12.0834H8.54163C10.0137 12.0834 11.8143 12.8725 13.2035 13.6298C14.014 14.0715 14.4192 14.2924 14.6846 14.2599C14.9307 14.2298 15.1168 14.1193 15.2611 13.9176C15.4166 13.7002 15.4166 13.2651 15.4166 12.3948V4.27195C15.4166 3.40171 15.4166 2.96659 15.2611 2.74912C15.1168 2.54747 14.9307 2.43697 14.6846 2.40682C14.4192 2.37432 14.014 2.59521 13.2035 3.03701C11.8143 3.79431 10.0136 4.58338 8.54162 4.58338Z"
        stroke="#101828"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ListingsIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.5 11H4.6C4.03995 11 3.75992 11 3.54601 11.109C3.35785 11.2049 3.20487 11.3578 3.10899 11.546C3 11.7599 3 12.0399 3 12.6V21M16.5 11H19.4C19.9601 11 20.2401 11 20.454 11.109C20.6422 11.2049 20.7951 11.3578 20.891 11.546C21 11.7599 21 12.0399 21 12.6V21M16.5 21V6.2C16.5 5.0799 16.5 4.51984 16.282 4.09202C16.0903 3.71569 15.7843 3.40973 15.408 3.21799C14.9802 3 14.4201 3 13.3 3H10.7C9.57989 3 9.01984 3 8.59202 3.21799C8.21569 3.40973 7.90973 3.71569 7.71799 4.09202C7.5 4.51984 7.5 5.0799 7.5 6.2V21M22 21H2M11 7H13M11 11H13M11 15H13"
        stroke="#101828"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ListingsIconSm() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.24996 9.16667H3.83329C3.36658 9.16667 3.13323 9.16667 2.95497 9.25749C2.79817 9.33739 2.67068 9.46487 2.59079 9.62167C2.49996 9.79993 2.49996 10.0333 2.49996 10.5V17.5M13.75 9.16667H16.1666C16.6333 9.16667 16.8667 9.16667 17.045 9.25749C17.2018 9.33739 17.3292 9.46487 17.4091 9.62167C17.5 9.79993 17.5 10.0333 17.5 10.5V17.5M13.75 17.5V5.16667C13.75 4.23325 13.75 3.76654 13.5683 3.41002C13.4085 3.09641 13.1535 2.84144 12.8399 2.68166C12.4834 2.5 12.0167 2.5 11.0833 2.5H8.91663C7.98321 2.5 7.5165 2.5 7.15998 2.68166C6.84637 2.84144 6.5914 3.09641 6.43162 3.41002C6.24996 3.76654 6.24996 4.23325 6.24996 5.16667V17.5M18.3333 17.5H1.66663M9.16663 5.83333H10.8333M9.16663 9.16667H10.8333M9.16663 12.5H10.8333"
        stroke="#101828"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function EmailIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.5 18L14.8571 12M9.14286 12L2.50003 18M2 7L10.1649 12.7154C10.8261 13.1783 11.1567 13.4097 11.5163 13.4993C11.8339 13.5785 12.1661 13.5785 12.4837 13.4993C12.8433 13.4097 13.1739 13.1783 13.8351 12.7154L22 7M6.8 20H17.2C18.8802 20 19.7202 20 20.362 19.673C20.9265 19.3854 21.3854 18.9265 21.673 18.362C22 17.7202 22 16.8802 22 15.2V8.8C22 7.11984 22 6.27976 21.673 5.63803C21.3854 5.07354 20.9265 4.6146 20.362 4.32698C19.7202 4 18.8802 4 17.2 4H6.8C5.11984 4 4.27976 4 3.63803 4.32698C3.07354 4.6146 2.6146 5.07354 2.32698 5.63803C2 6.27976 2 7.11984 2 8.8V15.2C2 16.8802 2 17.7202 2.32698 18.362C2.6146 18.9265 3.07354 19.3854 3.63803 19.673C4.27976 20 5.11984 20 6.8 20Z"
        stroke="#101828"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function EmailIconSm() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.9166 15L12.3809 10M7.61901 10L2.08332 15M1.66663 5.83337L8.47073 10.5962C9.0217 10.9819 9.29719 11.1748 9.59685 11.2495C9.86154 11.3154 10.1384 11.3154 10.4031 11.2495C10.7027 11.1748 10.9782 10.9819 11.5292 10.5962L18.3333 5.83337M5.66663 16.6667H14.3333C15.7334 16.6667 16.4335 16.6667 16.9683 16.3942C17.4387 16.1545 17.8211 15.7721 18.0608 15.3017C18.3333 14.7669 18.3333 14.0668 18.3333 12.6667V7.33337C18.3333 5.93324 18.3333 5.23318 18.0608 4.6984C17.8211 4.22799 17.4387 3.84554 16.9683 3.60586C16.4335 3.33337 15.7334 3.33337 14.3333 3.33337H5.66663C4.26649 3.33337 3.56643 3.33337 3.03165 3.60586C2.56124 3.84554 2.17879 4.22799 1.93911 4.6984C1.66663 5.23318 1.66663 5.93324 1.66663 7.33337V12.6667C1.66663 14.0668 1.66663 14.7669 1.93911 15.3017C2.17879 15.7721 2.56124 16.1545 3.03165 16.3942C3.56643 16.6667 4.26649 16.6667 5.66663 16.6667Z"
        stroke="#101828"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function PolygonIcon() {
  return (
    <svg
      width="10"
      height="20"
      viewBox="0 0 10 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.707106 10.7071C0.316582 10.3166 0.316583 9.68342 0.707107 9.29289L10 0L10 20L0.707106 10.7071Z"
        fill="#ECF1F4"
      />
    </svg>
  );
}

export function BuildingIcon() {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.74984 9.16667H4.33317C3.86646 9.16667 3.63311 9.16667 3.45485 9.25749C3.29804 9.33739 3.17056 9.46487 3.09067 9.62167C2.99984 9.79993 2.99984 10.0333 2.99984 10.5V17.5M14.2498 9.16667H16.6665C17.1332 9.16667 17.3666 9.16667 17.5448 9.25749C17.7016 9.33739 17.8291 9.46487 17.909 9.62167C17.9998 9.79993 17.9998 10.0333 17.9998 10.5V17.5M14.2498 17.5V5.16667C14.2498 4.23325 14.2498 3.76654 14.0682 3.41002C13.9084 3.09641 13.6534 2.84144 13.3398 2.68166C12.9833 2.5 12.5166 2.5 11.5832 2.5H9.4165C8.48308 2.5 8.01637 2.5 7.65985 2.68166C7.34625 2.84144 7.09128 3.09641 6.93149 3.41002C6.74984 3.76654 6.74984 4.23325 6.74984 5.16667V17.5M18.8332 17.5H2.1665M9.6665 5.83333H11.3332M9.6665 9.16667H11.3332M9.6665 12.5H11.3332"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ResidentialIcon({ size = 21 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_7353_8503)">
        <path
          d="M11.4409 6.95984C10.9639 7.29992 10.3801 7.49996 9.74967 7.49996C8.13884 7.49996 6.83301 6.19412 6.83301 4.58329C6.83301 2.97246 8.13884 1.66663 9.74967 1.66663C10.7938 1.66663 11.7098 2.21531 12.2251 3.04008M5.16634 16.7393H7.34158C7.6252 16.7393 7.90708 16.773 8.18202 16.8405L10.4804 17.399C10.9791 17.5205 11.4987 17.5323 12.0026 17.4345L14.5438 16.9401C15.2151 16.8093 15.8327 16.4878 16.3166 16.017L18.1146 14.2681C18.628 13.7694 18.628 12.9603 18.1146 12.4608C17.6523 12.0112 16.9203 11.9605 16.3973 12.3419L14.3018 13.8707C14.0017 14.09 13.6366 14.2082 13.2611 14.2082H11.2376L12.5256 14.2081C13.2515 14.2081 13.8396 13.6361 13.8396 12.9299V12.6742C13.8396 12.0879 13.4293 11.5766 12.8447 11.4349L10.8568 10.9514C10.5333 10.8729 10.202 10.8333 9.86896 10.8333C9.06495 10.8333 7.60959 11.499 7.60959 11.499L5.16634 12.5207M16.833 5.41663C16.833 7.02746 15.5272 8.33329 13.9163 8.33329C12.3055 8.33329 10.9997 7.02746 10.9997 5.41663C10.9997 3.8058 12.3055 2.49996 13.9163 2.49996C15.5272 2.49996 16.833 3.8058 16.833 5.41663ZM1.83301 12.1666L1.83301 17C1.83301 17.4667 1.83301 17.7 1.92384 17.8783C2.00373 18.0351 2.13121 18.1626 2.28802 18.2425C2.46628 18.3333 2.69963 18.3333 3.16634 18.3333H3.83301C4.29972 18.3333 4.53307 18.3333 4.71133 18.2425C4.86813 18.1626 4.99562 18.0351 5.07551 17.8783C5.16634 17.7 5.16634 17.4667 5.16634 17V12.1666C5.16634 11.6999 5.16634 11.4666 5.07551 11.2883C4.99562 11.1315 4.86814 11.004 4.71133 10.9241C4.53307 10.8333 4.29972 10.8333 3.83301 10.8333L3.16634 10.8333C2.69963 10.8333 2.46628 10.8333 2.28802 10.9241C2.13121 11.004 2.00373 11.1315 1.92384 11.2883C1.83301 11.4666 1.83301 11.6999 1.83301 12.1666Z"
          stroke="#101828"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_7353_8503">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0.166504)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function BigBuildingIcon() {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_7353_8508)">
        <path
          d="M19.1667 17.5V15.8333C19.1667 14.2801 18.1044 12.9751 16.6667 12.605M13.75 2.7423C14.9716 3.23679 15.8333 4.43443 15.8333 5.83333C15.8333 7.23224 14.9716 8.42988 13.75 8.92437M15 17.5C15 15.9469 15 15.1703 14.7463 14.5577C14.408 13.741 13.759 13.092 12.9423 12.7537C12.3297 12.5 11.5531 12.5 10 12.5H7.5C5.94686 12.5 5.17029 12.5 4.55772 12.7537C3.74096 13.092 3.09205 13.741 2.75373 14.5577C2.5 15.1703 2.5 15.9469 2.5 17.5M12.0833 5.83333C12.0833 7.67428 10.5909 9.16667 8.75 9.16667C6.90905 9.16667 5.41667 7.67428 5.41667 5.83333C5.41667 3.99238 6.90905 2.5 8.75 2.5C10.5909 2.5 12.0833 3.99238 12.0833 5.83333Z"
          stroke="#101828"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_7353_8508">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0.833496)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function WifiIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.6666 8.33329V5.66663C16.6666 4.26649 16.6666 3.56643 16.3941 3.03165C16.1544 2.56124 15.772 2.17879 15.3016 1.93911C14.7668 1.66663 14.0667 1.66663 12.6666 1.66663H7.33325C5.93312 1.66663 5.23306 1.66663 4.69828 1.93911C4.22787 2.17879 3.84542 2.56124 3.60574 3.03165C3.33325 3.56643 3.33325 4.26649 3.33325 5.66663V14.3333C3.33325 15.7334 3.33325 16.4335 3.60574 16.9683C3.84542 17.4387 4.22787 17.8211 4.69828 18.0608C5.23306 18.3333 5.93312 18.3333 7.33325 18.3333H9.99992M10.4166 9.16663H6.66659M7.49992 12.5H6.66659M13.3333 5.83329H6.66659M14.1643 12.3588C13.4979 11.6013 12.3865 11.3975 11.5515 12.0912C10.7165 12.7848 10.5989 13.9445 11.2547 14.7649C11.9104 15.5853 14.1643 17.5 14.1643 17.5C14.1643 17.5 16.4182 15.5853 17.074 14.7649C17.7297 13.9445 17.6265 12.7775 16.7771 12.0912C15.9278 11.4048 14.8308 11.6013 14.1643 12.3588Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SupportIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_7353_8777)">
        <path
          d="M7.57508 7.49996C7.771 6.94302 8.15771 6.47338 8.66671 6.17424C9.17571 5.87509 9.77416 5.76574 10.3561 5.86555C10.938 5.96536 11.4658 6.2679 11.846 6.71957C12.2262 7.17124 12.4343 7.74289 12.4334 8.33329C12.4334 9.99996 9.93342 10.8333 9.93342 10.8333M10.0001 14.1666H10.0084M18.3334 9.99996C18.3334 14.6023 14.6025 18.3333 10.0001 18.3333C5.39771 18.3333 1.66675 14.6023 1.66675 9.99996C1.66675 5.39759 5.39771 1.66663 10.0001 1.66663C14.6025 1.66663 18.3334 5.39759 18.3334 9.99996Z"
          stroke="#101828"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_7353_8777">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function IntractiveIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.50008 13.3334V6.00004C2.50008 5.06662 2.50008 4.59991 2.68174 4.24339C2.84153 3.92979 3.09649 3.67482 3.4101 3.51503C3.76662 3.33337 4.23333 3.33337 5.16675 3.33337H14.8334C15.7668 3.33337 16.2335 3.33337 16.5901 3.51503C16.9037 3.67482 17.1586 3.92979 17.3184 4.24339C17.5001 4.59991 17.5001 5.06662 17.5001 6.00004V13.3334H13.0524C12.8485 13.3334 12.7466 13.3334 12.6507 13.3564C12.5657 13.3768 12.4844 13.4105 12.4098 13.4562C12.3257 13.5077 12.2537 13.5798 12.1096 13.7239L12.0573 13.7762C11.9131 13.9203 11.8411 13.9924 11.757 14.0439C11.6824 14.0896 11.6011 14.1233 11.5161 14.1437C11.4202 14.1667 11.3183 14.1667 11.1145 14.1667H8.8857C8.68187 14.1667 8.57996 14.1667 8.48406 14.1437C8.39902 14.1233 8.31774 14.0896 8.24318 14.0439C8.15908 13.9924 8.08702 13.9203 7.94289 13.7762L7.89061 13.7239C7.74648 13.5798 7.67442 13.5077 7.59032 13.4562C7.51576 13.4105 7.43447 13.3768 7.34944 13.3564C7.25354 13.3334 7.15162 13.3334 6.9478 13.3334H2.50008ZM2.50008 13.3334C2.03984 13.3334 1.66675 13.7065 1.66675 14.1667V14.4445C1.66675 14.9611 1.66675 15.2195 1.72354 15.4314C1.87765 16.0066 2.3269 16.4558 2.90205 16.6099C3.11399 16.6667 3.37232 16.6667 3.88897 16.6667H16.1112C16.6278 16.6667 16.8862 16.6667 17.0981 16.6099C17.6733 16.4558 18.1225 16.0066 18.2766 15.4314C18.3334 15.2195 18.3334 14.9611 18.3334 14.4445C18.3334 14.1862 18.3334 14.057 18.305 13.951C18.228 13.6634 18.0033 13.4388 17.7158 13.3618C17.6098 13.3334 17.4806 13.3334 17.2223 13.3334H16.6667"
        stroke="#101828"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SchoolIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.16675 8.33331V13.3426C4.16675 13.6417 4.16675 13.7913 4.21229 13.9233C4.25257 14.0401 4.3183 14.1465 4.40473 14.2347C4.50247 14.3345 4.63625 14.4014 4.9038 14.5352L9.4038 16.7852C9.62243 16.8945 9.73175 16.9491 9.84642 16.9707C9.94797 16.9897 10.0522 16.9897 10.1537 16.9707C10.2684 16.9491 10.3777 16.8945 10.5964 16.7852L15.0964 14.5352C15.3639 14.4014 15.4977 14.3345 15.5954 14.2347C15.6819 14.1465 15.7476 14.0401 15.7879 13.9233C15.8334 13.7913 15.8334 13.6417 15.8334 13.3426V8.33331M1.66675 7.08331L9.70194 3.06571C9.81126 3.01105 9.86592 2.98372 9.92325 2.97297C9.97403 2.96344 10.0261 2.96344 10.0769 2.97297C10.1342 2.98372 10.1889 3.01105 10.2982 3.06571L18.3334 7.08331L10.2982 11.1009C10.1889 11.1556 10.1342 11.1829 10.0769 11.1936C10.0261 11.2032 9.97403 11.2032 9.92325 11.1936C9.86592 11.1829 9.81126 11.1556 9.70194 11.1009L1.66675 7.08331Z"
        stroke="#101828"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
